/* =====================================================================
   Brick Bagz - LEGO Bag Finder (v2)
   - Dropdown with set photos + coloured "Recommended" bag card
   - Press Enter / "View all" -> full results page
   - Click a set -> correct bag page, quantity pre-filled
   ===================================================================== */

/* ---------- SETTINGS (safe to edit) ---------- */
window.BBZ_FINDER_CONFIG = window.BBZ_FINDER_CONFIG || {
  sheetUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTGWoAoWFFVrIhwLJULqCa3DjHLbWhMfTZJsXHpVJWmhnyJ9Tuk4WBP1ZIzCPIetXI4qTLzZV2vN9kx/pub?gid=1447003669&single=true&output=csv',
  resultsPage: '/pages/search',   // change if you rename the Find My Bagz page
  dropdownLimit: 5,               // sets shown in the dropdown
  resultsPageSize: 24,            // sets per "Load more" on the results page
  minCharacters: 2,
  fallbackHandle: 'medium-brick-bagz',
  fallbackImage: 'https://cdn.shopify.com/s/files/1/0908/2817/7751/files/all.jpg?v=1745903082',
  bags: {
    'small':   { label: 'Small',       range: 'Under 200 bricks',   colour: 'Red',    handle: 'small-brick-bagz',       image: 'https://cdn.shopify.com/s/files/1/0908/2817/7751/files/small.jpg?v=1745902761' },
    'medium':  { label: 'Medium',      range: '200 \u2013 500 bricks',   colour: 'Yellow', handle: 'medium-brick-bagz',      image: 'https://cdn.shopify.com/s/files/1/0908/2817/7751/files/medium.jpg?v=1745902764' },
    'large':   { label: 'Large',       range: '500 \u2013 700 bricks',   colour: 'Green',  handle: 'large-brick-bagz',       image: 'https://cdn.shopify.com/s/files/1/0908/2817/7751/files/large.jpg?v=1745902762' },
    'x-large': { label: 'Extra Large', range: '700 \u2013 1,500 bricks', colour: 'Blue',   handle: 'extra-large-brick-bagz', image: 'https://cdn.shopify.com/s/files/1/0908/2817/7751/files/xlarge.jpg?v=1745902763' }
  }
};

if (typeof window.LegoBagFinder === 'undefined') {
  (function () {
    var CFG = window.BBZ_FINDER_CONFIG;

    /* ---------- helpers ---------- */
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function norm(s) {
      return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    }
    function isTrue(v) { return String(v || '').trim().toUpperCase() === 'TRUE'; }
    function fmt(n) { return (Number(n) || 0).toLocaleString('en-GB'); }
    function sizedImage(src, width) {
      if (!src) return '';
      if (src.indexOf('//') === 0) src = 'https:' + src;
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
    }
    function setImage(set) {
      if (set.image && /^https?:\/\//i.test(set.image)) return set.image;
      var id = String(set.id || '').trim();
      if (!id) return '';
      if (id.indexOf('-') === -1) id += '-1';
      return 'https://cdn.rebrickable.com/media/thumbs/sets/' + encodeURIComponent(id) + '.jpg/250x250p.jpg';
    }
    // Keeps links working if a country/language folder (e.g. /en-us/) is ever added
    var ROOT = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
    function siteUrl(path) { return ROOT + path; }
    function resultsUrl(q) {
      return siteUrl(CFG.resultsPage) + '?q=' + encodeURIComponent(q);
    }

    /* Proper CSV parser - handles quotes and commas inside names */
    function parseCsv(text) {
      var rows = [], row = [], field = '', i = 0, inQ = false, c;
      text = text.replace(/^\uFEFF/, '');
      while (i < text.length) {
        c = text[i];
        if (inQ) {
          if (c === '"') {
            if (text[i + 1] === '"') { field += '"'; i++; } else { inQ = false; }
          } else { field += c; }
        } else if (c === '"') { inQ = true; }
        else if (c === ',') { row.push(field); field = ''; }
        else if (c === '\n') { row.push(field); rows.push(row); row = []; field = ''; }
        else if (c !== '\r') { field += c; }
        i++;
      }
      if (field !== '' || row.length) { row.push(field); rows.push(row); }
      if (!rows.length) return [];
      var headers = rows[0].map(function (h) { return h.trim(); });
      var out = [];
      for (var r = 1; r < rows.length; r++) {
        if (rows[r].length < 2) continue;
        var item = {};
        headers.forEach(function (h, j) { item[h] = (rows[r][j] || '').trim(); });
        out.push(item);
      }
      return out;
    }

    function prepareSet(s) {
      var size = s.recommendedBags || '';
      if (size.charAt(0) === '[') { try { size = JSON.parse(size)[0] || ''; } catch (e) {} }
      s.size = String(size).trim().toLowerCase();
      s.pieces = parseInt(String(s.pieces).replace(/,/g, ''), 10) || 0;
      s.bagCount = parseInt(s.bagCount, 10) || 0;
      s.noBagNeeded = isTrue(s.noBag);
      s._id = norm(s.id);
      s._name = norm(s.name);
      s._theme = norm(s.theme);
      s._hay = s._id + ' ' + s._name + ' ' + s._theme;
      return s;
    }

    /* ---------- data: loaded ONCE and shared by every search box ---------- */
    var dataPromise = null;
    function loadData() {
      if (dataPromise) return dataPromise;
      var sheet = fetch(CFG.sheetUrl)
        .then(function (r) { if (!r.ok) throw new Error('Sheet ' + r.status); return r.text(); })
        .then(function (t) {
          return parseCsv(t).map(prepareSet).filter(function (s) {
            return s.id && s.name && !isTrue(s.hideFromSearch) && s.name.indexOf('{?}') === -1;
          });
        });
      // Pull the matching-colour photo for each bag size from the live products
      var bagPhotos = Promise.all(Object.keys(CFG.bags).map(function (key) {
        var bag = CFG.bags[key];
        return fetch('/products/' + bag.handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (!p) return;
            var v = (p.variants || []).filter(function (v) {
              return (v.title || '').toLowerCase() === bag.colour.toLowerCase();
            })[0];
            var src = (v && v.featured_image && v.featured_image.src) || p.featured_image;
            if (src) bag.photo = sizedImage(src, 200);
          })
          .catch(function () {});
      }));
      dataPromise = Promise.all([sheet, bagPhotos]).then(function (res) {
        console.log('Brick Bagz finder: ' + res[0].length + ' sets loaded');
        return res[0];
      });
      var thisLoad = dataPromise;
      dataPromise.catch(function (e) {
        console.error('Brick Bagz finder: could not load sets', e);
        if (dataPromise === thisLoad) dataPromise = null;   // let the next search try again
      });
      return dataPromise;
    }

    /* ---------- search ---------- */
    function search(sets, query) {
      var q = norm(query);
      if (!q) return [];
      var tokens = q.split(/\s+/);
      var hits = [];
      for (var i = 0; i < sets.length; i++) {
        var s = sets[i], ok = true;
        for (var t = 0; t < tokens.length; t++) {
          if (s._hay.indexOf(tokens[t]) === -1) { ok = false; break; }
        }
        if (!ok) continue;
        // Lower score = shown first. Ties go to the bigger set (they need bags most).
        var score =
          s._id === q ? 0 :                                   // exact set number
          s._id.indexOf(q) === 0 ? 1 :                        // set number starts with
          s._name === q ? 2 :                                 // exact name
          s._theme === q ? 3 :                                // exact theme, e.g. "star wars"
          (s._name.indexOf(q) === 0 || s._name.indexOf(' ' + q) > -1) ? 4 : // a word in the name
          s._name.indexOf(q) > -1 ? 5 :
          s._theme.indexOf(q) > -1 ? 6 : 7;
        hits.push({ s: s, score: score });
      }
      hits.sort(function (a, b) { return a.score - b.score || b.s.pieces - a.s.pieces; });
      return hits.map(function (h) { return h.s; });
    }

    /* ---------- rendering ---------- */
    var ICON_BOX = '<svg class="bbz-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2 3 6.5v11L12 22l9-4.5v-11L12 2Zm0 2.2 6.6 3.3L12 10.8 5.4 7.5 12 4.2ZM5 9.1l6 3v7.3l-6-3V9.1Zm8 10.3v-7.3l6-3v7.3l-6 3Z"/></svg>';
    var ICON_CHEVRON = '<svg class="bbz-chev" viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function productUrl(set) {
      var bag = CFG.bags[set.size];
      var url = siteUrl('/products/' + (bag ? bag.handle : CFG.fallbackHandle));
      if (set.bagCount > 1) url += '?quantity=' + set.bagCount;
      return url;
    }

    function rowHtml(set) {
      var bag = CFG.bags[set.size];
      var meta = 'Set #' + esc(set.id) +
        (set.theme ? ' <span class="bbz-sep">|</span> ' + esc(set.theme) : '') +
        (set.year ? ' <span class="bbz-sep">|</span> ' + esc(set.year) : '');
      var bagImg = bag ? (bag.photo || bag.image) : CFG.fallbackImage;

      var rec;
      if (set.noBagNeeded) {
        rec = '<div class="bbz-rec bbz-rec--none"><div class="bbz-rec-text">' +
          '<div class="bbz-rec-size">No bag needed</div>' +
          '<div class="bbz-rec-range">This set is small enough to keep anywhere!</div></div></div>';
      } else if (!bag) {
        rec = '<div class="bbz-rec bbz-rec--none"><div class="bbz-rec-text">' +
          '<div class="bbz-rec-size">Size not found</div>' +
          '<div class="bbz-rec-range">Contact us and we\'ll help</div></div></div>';
      } else {
        rec = '<div class="bbz-rec bbz-rec--' + set.size + '">' +
          '<img class="bbz-rec-img" src="' + esc(bagImg) + '" alt="' + esc(bag.label) + ' Brick Bag" loading="lazy">' +
          '<div class="bbz-rec-text">' +
            '<div class="bbz-rec-label">Recommended:</div>' +
            '<div class="bbz-rec-size">' + esc(bag.label) + '</div>' +
            '<div class="bbz-rec-range">' + esc(bag.range) + '</div>' +
            (set.bagCount > 1 ? '<div class="bbz-rec-count">You\'ll need ' + set.bagCount + ' bags</div>' : '') +
          '</div>' + ICON_CHEVRON + '</div>';
      }

      var inner =
        '<div class="bbz-set-img"><img src="' + esc(setImage(set)) + '" data-fallback="' + esc(bagImg) + '" alt="LEGO\u00AE set ' + esc(set.id) + ' ' + esc(set.name) + '" loading="lazy"></div>' +
        '<div class="bbz-set-info">' +
          '<div class="bbz-set-name">' + esc(set.name) + '</div>' +
          '<div class="bbz-set-meta">' + meta + '</div>' +
          (set.pieces ? '<div class="bbz-set-pieces">' + ICON_BOX + fmt(set.pieces) + ' pieces</div>' : '') +
        '</div>' + rec;

      if (set.noBagNeeded || !bag) return '<div class="bbz-row bbz-row--static">' + inner + '</div>';
      return '<a class="bbz-row" href="' + esc(productUrl(set)) + '">' + inner + '</a>';
    }

    function wireImageFallbacks(root) {
      root.querySelectorAll('img[data-fallback]').forEach(function (img) {
        if (img.__bbzWired) return;
        img.__bbzWired = true;
        img.addEventListener('error', function () {
          var fb = img.getAttribute('data-fallback');
          img.removeAttribute('data-fallback');
          if (fb && img.src !== fb) { img.src = fb; img.parentNode.classList.add('bbz-set-img--bag'); }
        });
      });
    }

    /* ---------- styles (injected once) ---------- */
    function injectStyles() {
      if (document.getElementById('bbz-finder-styles')) return;
      var css = [
        '.bbz-dropdown{position:absolute;z-index:9999;background:#fff;border-radius:14px;box-shadow:0 12px 40px rgba(20,33,61,.18);border:1px solid #e3e7f0;max-height:72vh;overflow-y:auto;display:none;font-family:inherit;color:#14213d}',
        '.bbz-row{display:grid;grid-template-columns:96px minmax(0,1fr) minmax(220px,300px);gap:16px;align-items:center;padding:12px 14px;border-bottom:1px solid #eef0f5;text-decoration:none!important;color:#14213d!important;background:#fff;transition:background .15s}',
        'a.bbz-row:hover,.bbz-row.is-selected{background:#f6f8fc}',
        '.bbz-set-img{width:96px;height:80px;display:flex;align-items:center;justify-content:center}',
        '.bbz-set-img img{max-width:100%;max-height:100%;object-fit:contain}',
        '.bbz-set-name{font-weight:700;font-size:17px;line-height:1.25;margin-bottom:4px}',
        '.bbz-set-meta{color:#7a8299;font-size:14px;margin-bottom:6px}',
        '.bbz-sep{margin:0 6px;color:#c3c8d6}',
        '.bbz-set-pieces{display:flex;align-items:center;gap:6px;font-size:14px;color:#2b3550}',
        '.bbz-ico{width:18px;height:18px;fill:#2b3550;flex:none}',
        '.bbz-rec{display:flex;align-items:center;gap:12px;border-radius:12px;padding:10px 12px;min-height:82px}',
        '.bbz-rec-img{width:64px;height:64px;object-fit:contain;flex:none}',
        '.bbz-rec-text{flex:1;min-width:0}',
        '.bbz-rec-label{font-size:12px;color:#4a5470}',
        '.bbz-rec-size{font-weight:800;font-size:18px;line-height:1.2}',
        '.bbz-rec-range{font-size:13px;color:#4a5470}',
        '.bbz-rec-count{font-size:13px;font-weight:700;margin-top:2px}',
        '.bbz-chev{width:20px;height:20px;flex:none;color:#14213d}',
        '.bbz-rec--small{background:#fbe2e1}.bbz-rec--small .bbz-rec-count{color:#8f2f29}',
        '.bbz-rec--medium{background:#fef4da}.bbz-rec--medium .bbz-rec-count{color:#9a750f}',
        '.bbz-rec--large{background:#e0f1e5}.bbz-rec--large .bbz-rec-count{color:#25693a}',
        '.bbz-rec--x-large{background:#e2eaf6}.bbz-rec--x-large .bbz-rec-count{color:#2e4e7c}',
        '.bbz-rec--none{background:#f1f3f7}',
        '.bbz-footer{position:sticky;bottom:0;display:flex;align-items:center;gap:8px;padding:14px 18px;background:#f6f8fc;color:#1e4fd0!important;font-weight:700;font-size:16px;text-decoration:none!important;border-top:1px solid #e3e7f0}',
        '.bbz-footer:hover{text-decoration:underline!important}',
        '.bbz-msg{padding:22px 18px;color:#4a5470;font-size:15px;text-align:center}',
        '.bbz-results{max-width:1100px;margin:30px auto 50px;padding:0 16px;color:#14213d}',
        '.bbz-results h2{font-size:24px;font-weight:800;margin:0 0 16px}',
        '.bbz-results-list{border:1px solid #e3e7f0;border-radius:14px;overflow:hidden;background:#fff}',
        '.bbz-more{display:block;margin:20px auto 0;padding:12px 28px;border-radius:999px;border:2px solid #1e4fd0;background:#fff;color:#1e4fd0;font-weight:700;font-size:15px;cursor:pointer}',
        '.bbz-more:hover{background:#1e4fd0;color:#fff}',
        '@media (max-width:640px){.bbz-row{grid-template-columns:72px minmax(0,1fr);gap:10px 12px}.bbz-set-img{width:72px;height:64px}.bbz-rec{grid-column:1 / -1;min-height:0}.bbz-set-name{font-size:15px}.bbz-rec-img{width:48px;height:48px}}'
      ].join('\n');
      var st = document.createElement('style');
      st.id = 'bbz-finder-styles';
      st.textContent = css;
      document.head.appendChild(st);
    }

    /* ---------- the search box (one per form) ---------- */
    class LegoBagFinder {
      constructor(form) {
        if (!form) return;
        if (form.__bbzFinder) return form.__bbzFinder;   // already set up, don't double up
        this.form = form;
        this.input = form.querySelector('input[type="search"], input[name="q"]');
        if (!this.input) return;
        form.__bbzFinder = this;
        injectStyles();

        this.box = document.createElement('div');
        this.box.className = 'bbz-dropdown lego-bag-finder__results';
        this.box.setAttribute('role', 'listbox');
        document.body.appendChild(this.box);
        this.timer = null;
        this.lastQuery = '';

        var self = this;
        this.input.setAttribute('autocomplete', 'off');
        this.input.addEventListener('input', function () { self.onInput(); });
        this.input.addEventListener('focus', function () { if (self.input.value.trim().length >= CFG.minCharacters) self.onInput(true); });
        this.input.addEventListener('keydown', function (e) { self.onKey(e); });
        form.addEventListener('submit', function (e) { self.onSubmit(e); });
        document.addEventListener('click', function (e) {
          if (!form.contains(e.target) && !self.box.contains(e.target)) self.hide();
        });
        window.addEventListener('resize', function () { self.position(); });
        window.addEventListener('scroll', function () { self.position(); }, { passive: true });
        // Only download the set list once someone actually uses the search box
        // (keeps ~850KB off every page load)
        ['focus', 'pointerdown', 'touchstart'].forEach(function (ev) {
          self.input.addEventListener(ev, function () { loadData(); }, { once: true, passive: true });
        });
      }

      onInput(immediate) {
        var self = this, q = this.input.value.trim();
        clearTimeout(this.timer);
        if (q.length < CFG.minCharacters) return this.hide();
        this.timer = setTimeout(function () { self.run(q); }, immediate ? 0 : 220);
      }

      run(q) {
        var self = this;
        this.lastQuery = q;
        this.showMessage('Searching\u2026');
        loadData().then(function (sets) {
          if (self.input.value.trim() !== q) return;   // user kept typing
          self.render(search(sets, q), q);
        }).catch(function () {
          self.showMessage('Sorry, the set finder is unavailable right now.');
        });
      }

      render(results, q) {
        if (!results.length) {
          return this.showMessage('No matching LEGO\u00AE sets found. Try the set number from the box.');
        }
        var shown = results.slice(0, CFG.dropdownLimit);
        var html = shown.map(rowHtml).join('');
        if (results.length > shown.length) {
          html += '<a class="bbz-footer" href="' + esc(resultsUrl(q)) + '">' +
            '<svg class="bbz-ico" viewBox="0 0 24 24" aria-hidden="true" style="fill:none;stroke:currentColor;stroke-width:2.2"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5" stroke-linecap="round"/></svg>' +
            'View all ' + fmt(results.length) + ' results for \u201C' + esc(q) + '\u201D \u2192</a>';
        }
        this.box.innerHTML = html;
        wireImageFallbacks(this.box);
        this.open();
      }

      showMessage(msg) {
        this.box.innerHTML = '<div class="bbz-msg">' + esc(msg) + '</div>';
        this.open();
      }

      open() { this.box.style.display = 'block'; this.position(); }
      hide() { this.box.style.display = 'none'; }

      position() {
        if (this.box.style.display !== 'block') return;
        var r = this.form.getBoundingClientRect();
        var vw = document.documentElement.clientWidth;
        var w = Math.min(Math.max(r.width, 680), vw - 16);
        var left = r.left + r.width / 2 - w / 2;
        left = Math.max(8, Math.min(left, vw - w - 8));
        this.box.style.width = w + 'px';
        this.box.style.left = (left + window.pageXOffset) + 'px';
        this.box.style.top = (r.bottom + window.pageYOffset + 8) + 'px';
      }

      rows() { return Array.prototype.slice.call(this.box.querySelectorAll('a.bbz-row')); }

      onKey(e) {
        if (e.key === 'Escape') return this.hide();
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        var rows = this.rows();
        if (!rows.length || this.box.style.display !== 'block') return;
        e.preventDefault();
        var i = rows.findIndex(function (r) { return r.classList.contains('is-selected'); });
        i = e.key === 'ArrowDown' ? (i + 1) % rows.length : (i <= 0 ? rows.length - 1 : i - 1);
        rows.forEach(function (r) { r.classList.remove('is-selected'); });
        rows[i].classList.add('is-selected');
        rows[i].scrollIntoView({ block: 'nearest' });
      }

      onSubmit(e) {
        e.preventDefault();
        var sel = this.box.querySelector('a.bbz-row.is-selected');
        if (sel && this.box.style.display === 'block') { window.location.href = sel.getAttribute('href'); return; }
        var q = this.input.value.trim();
        if (q) window.location.href = resultsUrl(q);
      }
    }

    /* ---------- full results page ---------- */
    function renderResultsPage() {
      if (window.__bbzResultsDone) return;
      var path = location.pathname.replace(/\/$/, '');
      var target = CFG.resultsPage.replace(/\/$/, '');
      var mount = document.getElementById('bbz-search-results');
      if (!mount && path.slice(-target.length) !== target) return;
      var q = (new URLSearchParams(location.search).get('q') || '').trim();
      if (!q) return;
      window.__bbzResultsDone = true;
      injectStyles();

      // Show the query in every search box on the page
      document.querySelectorAll('input[type="search"], input[name="q"]').forEach(function (i) { i.value = q; });

      if (!mount) {
        mount = document.createElement('div');
        mount.id = 'bbz-search-results';
        var anchor = document.querySelector('.search-block');
        var section = anchor && anchor.closest('.shopify-section');
        var main = document.querySelector('main') || document.getElementById('MainContent') || document.body;
        if (section && section.parentNode) section.parentNode.insertBefore(mount, section.nextSibling);
        else main.insertBefore(mount, main.firstChild);
      }
      mount.className = 'bbz-results';
      mount.innerHTML = '<div class="bbz-msg">Searching\u2026</div>';

      loadData().then(function (sets) {
        var results = search(sets, q), shown = 0;
        if (!results.length) {
          mount.innerHTML = '<h2>No sets found for \u201C' + esc(q) + '\u201D</h2><div class="bbz-msg">Try the set number printed on your box, or a shorter name.</div>';
          return;
        }
        mount.innerHTML = '<h2>' + fmt(results.length) + ' result' + (results.length === 1 ? '' : 's') + ' for \u201C' + esc(q) + '\u201D</h2>' +
          '<div class="bbz-results-list"></div><button type="button" class="bbz-more">Load more sets</button>';
        var list = mount.querySelector('.bbz-results-list');
        var more = mount.querySelector('.bbz-more');
        function next() {
          var batch = results.slice(shown, shown + CFG.resultsPageSize);
          list.insertAdjacentHTML('beforeend', batch.map(rowHtml).join(''));
          shown += batch.length;
          wireImageFallbacks(list);
          more.style.display = shown < results.length ? 'block' : 'none';
        }
        more.addEventListener('click', next);
        next();
      }).catch(function () {
        mount.innerHTML = '<div class="bbz-msg">Sorry, the set finder is unavailable right now. Please try again shortly.</div>';
      });
    }

    /* ---------- start up (safe to call many times) ---------- */
    function initializeLegoBagFinder() {
      document.querySelectorAll('.search-block form.search-form, .serh-container .serh-form, .bbz-search form').forEach(function (f) {
        new LegoBagFinder(f);
      });
      renderResultsPage();
    }

    window.LegoBagFinder = LegoBagFinder;
    window.initializeLegoBagFinder = initializeLegoBagFinder;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeLegoBagFinder);
    else initializeLegoBagFinder();
    window.addEventListener('load', initializeLegoBagFinder);
  })();
}

/* ---------- Pre-fill quantity from ?quantity= (set by the finder) ---------- */
if (!window.__bbzQtyDone) {
  window.__bbzQtyDone = true;
  var bbzPrefillQty = function () {
    var qty = parseInt(new URLSearchParams(window.location.search).get('quantity'), 10);
    if (!qty || qty < 2 || qty > 50) return;
    document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      input.value = qty;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bbzPrefillQty);
  else bbzPrefillQty();
}